import { useCallback } from 'react';

import { useOrganizationScopeOrNull } from 'components/OrganizationScope/context';
import { orgPath } from 'constants/routes';
import { useMe } from 'hooks/useMe';

/**
 * 現在の組織スコープ内パスを生成する。
 * OrganizationScope 内はルートの組織を、ADMIN グローバル画面では /me の先頭の
 * 所属（ADMIN は単一所属）を使う。組織を特定できない場合は素のパスを返し、
 * '/' のエントリールーティングに解決を委ねる。
 */
export function useOrgPath(): (route: string) => string {
  const scope = useOrganizationScopeOrNull();
  const { data: me } = useMe();
  const organizationId =
    scope?.organizationId ?? me?.memberships?.[0]?.organizationId ?? null;

  return useCallback(
    (route: string) =>
      organizationId === null ? route : orgPath(organizationId, route),
    [organizationId],
  );
}
